import { render, staticRenderFns } from "./shopPremiumTemplate.vue?vue&type=template&id=aabb44e8&"
import script from "./shopPremiumTemplate.vue?vue&type=script&lang=js&"
export * from "./shopPremiumTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports